import React, { useState } from 'react';
import { exportTableAsCSV } from '../tableUtils';
import { DownloadOutlined } from '@ant-design/icons';
import { getSessionId } from '../../NexaStore';
import apptracker from '@src/utils/sensor/apptracker';
import { NEXA_TABLE_EXPORT } from '@src/utils/sensor/track';
import { TableContainer, StyledTable, DownloadButton } from './styled';

// Custom table component with floating download icon
const MarkTable: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [showDownloadButton, setShowDownloadButton] = useState(false);
  const tableRef = React.useRef<HTMLTableElement>(null);

  const handleDownload = () => {
    if (tableRef.current) {
      exportTableAsCSV(tableRef.current);

      const id = getSessionId();
      apptracker(NEXA_TABLE_EXPORT, { id });
    }
  };

  return (
    <TableContainer
      onMouseEnter={() => setShowDownloadButton(true)}
      onMouseLeave={() => setShowDownloadButton(false)}
    >
      <StyledTable ref={tableRef}>{children}</StyledTable>
      {showDownloadButton && (
        <DownloadButton
          type="text"
          size="small"
          icon={<DownloadOutlined />}
          onClick={handleDownload}
          title="Download"
        />
      )}
    </TableContainer>
  );
};

export default MarkTable;
